"use client";

import { useSidebar } from "@/contexts/sidebar-context";
import { useLanguage } from "@/contexts/language-context";
import { ReactNode } from "react";

interface LayoutContentProps {
  children: ReactNode;
}

export default function LayoutContent({ children }: LayoutContentProps) {
  const { isOpen } = useSidebar();
  const { isRTL } = useLanguage();

  // In RTL mode, sidebar is on right, so we need margin-right instead of margin-left
  const marginClass = isRTL ? (isOpen ? 'md:mr-[280px]' : 'md:mr-0') : isOpen ? 'md:ml-[280px]' : 'md:ml-0';

  return (
    <main className={`ml-0 mr-0 min-w-0 flex-1 transition-all duration-300 ${marginClass}`}>
      {children}
    </main>
  );
}
